var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropboxLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99998 0.962402L0 4.81144L5.99998 8.60388L12 4.81144L5.99998 0.962402ZM17.9999 0.962402L12 4.81144L17.9999 8.60388L23.9999 4.81144L17.9999 0.962402ZM0 12.4529L5.99998 16.302L12 12.4529L5.99998 8.60388L0 12.4529ZM17.9999 8.60388L12 12.4529L17.9999 16.302L23.9999 12.4529L17.9999 8.60388ZM5.99998 17.5472L12 21.3963L17.9999 17.5472L12 13.7548L5.99998 17.5472Z",
    fill: "#0062FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropboxLogo);
export default __webpack_public_path__ + "static/media/dropbox-logo.fd13f327396eeb6214cc11a509e18155.svg";
export { ForwardRef as ReactComponent };